import React, {Fragment} from 'react';
import {Button, Icon, Typography} from '@bonprix/design-system';
import Url from '@core/scripts/helper/url.js';
import {TrinityEvents} from '@checkout/components/tracking/trinity-events.ts';
import {Page} from '@checkout/components/tracking/model/Page.ts';
import {EventObjectType} from '@checkout/components/tracking/model/EventObjectType.ts';

export default function WishlistEmptylist({texts, userIsLoggedIn}) {
    const handleOnLoginClick = () => {
        const attributes = TrinityEvents.getClickAttributes(
            'emptyWishlist_login',
            Page.WISHLIST,
            EventObjectType.BUTTON,
        );
        TrinityEvents.createAndSendTrinityEvent(2, 'CLICK_WISHLIST_EMPTY', attributes);

        window.location.href = Url.toAbsolute('/buy/login/?checkout&target=/list/wishlist/');
    };

    const handleOnContinueShoppingClick = () => {
        const attributes = TrinityEvents.getClickAttributes(
            'emptyWishlist_continue',
            Page.WISHLIST,
            EventObjectType.BUTTON,
        );
        TrinityEvents.createAndSendTrinityEvent(2, 'CLICK_WISHLIST_EMPTY', attributes);

        window.location.href = Url.toAbsolute('/');
    };

    const renderButtons = () => {
        if (!userIsLoggedIn) {
            return (
                <>
                    <Button onClick={handleOnLoginClick} size="large">
                        {texts.wishlist_emptyWishlistLogin}
                    </Button>
                    <Button onClick={handleOnContinueShoppingClick} variant="secondary" size="large">
                        {texts.wishlist_continue_shopping_with_bonprix}
                    </Button>
                </>
            );
        }

        return (
            <Button onClick={handleOnContinueShoppingClick} size="large">
                {texts.wishlist_continue_shopping_with_bonprix}
            </Button>
        );
    };

    return (
        <>
            <div className="wishlist__container">
                <div className="wishlist__emptylist pt-5 pb-10">
                    <div className="text-center pb-5">
                        <Icon variant="heart" className="w-8 h-8" />
                    </div>
                    <div className="wishlist__empty">
                        <div className="pb-2">
                            <Typography variant="bonprix-h5" component="h2" align="center">
                                {texts.wishlist_emptyWishlistHeadline}
                            </Typography>
                        </div>
                        <Typography variant="body1" align="center">
                            {texts.wishlist_emptyWishlistInstructions}
                        </Typography>
                    </div>
                    <div className="space-y-4 s:pt-8 s:mx-4 l:max-w-100 l:m-auto">{renderButtons()}</div>
                </div>
            </div>
        </>
    );
}
